







import { faShareAlt } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '@nuxtjs/composition-api'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    SharePopover: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Header/SharePopover.vue'
      )
    )
  },
  data() {
    return {
      showPopover: false
    }
  },
  computed: {
    icons: () => ({
      shareAlt: faShareAlt
    })
  }
})
